import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import { GlobalContext } from '../../contexts/GlobalContext';
import { primary } from '../../theme/colors'
import React, { useContext, useState } from 'react';
import Btn from "../../components/Btn/Btn";
import './OurStore.css'
import SlideStore from "../../components/SlideStore/SlideStore";
import Location from "../../components/Location/Location";


const OurStore = () => {
    const [selectedBtnIndex, setSelectedBtnIndex] = useState(0)
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/ourStores.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        pageSubtitle,
        buttons,
        cardStore
    } = data

    const handleButtonClick = (index) => {
        setSelectedBtnIndex(index)
    }

    return (

        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
            />
            <div className="main-container">
                <section className="section-container">
                    <div className="control-container-page-title">
                        <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    </div>
                    <div className="container-store-btn">
                        {buttons.map((button, i) => {
                            return (
                                <Btn
                                    key={i}
                                    isSelected={selectedBtnIndex === i}
                                    type={'custom-outline'}
                                    label={button.stateAirport}
                                    color={primary.primary100}
                                    _function={() => handleButtonClick(i)}
                                />
                            )
                        })}
                    </div>
                    <div className='container-carrossel-card'>
                        <SlideStore
                            data={cardStore}
                            selectedSlideIndex={selectedBtnIndex}
                            onSlideChange={setSelectedBtnIndex} />
                    </div>
                    <Location coordsMap={cardStore}/>
                </section>
            </div>
        </>
    )

}

export default OurStore;